<ng-container
  *ngIf="
    isCurrentSiteLoading$ || isCurrentServiceSchedulesLoading$ | async;
    else content
  ">
  <div class="site-detail-wrapper">
    <mat-progress-bar
      mode="indeterminate"
      [color]="'accent'"
      [style.height]="'2px'"></mat-progress-bar>
  </div>
</ng-container>
<ng-template #content>
  <div class="site-detail-wrapper" *ngIf="currentSite$ | async as currentSite">
    <app-top-sub-nav
      [title]="currentSite.name"
      [showBackButton]="true"
      [backButtonUrl]="backButtonUrl">
    </app-top-sub-nav>
    <router-outlet></router-outlet>
  </div>
</ng-template>
